import React from 'react';
import { TypeOperasionalResource } from 'pages/OperationalPage';
import {
  Divider,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Theme,
  Typography
} from '@material-ui/core';
import { HeaderRow, TableCellHead, TableCustom } from 'components';
import { Autocomplete, Skeleton } from '@material-ui/lab';
import OperationalBody from './OperationalBody';
import { formatAccountCategoryNumber } from 'utils';

interface Props {
  costNumber?: string;
  name?: string;
  subAccountCategoriesId?: number | null;
  setSubAccountCategoriesId: React.Dispatch<React.SetStateAction<number | null>>;
  financialAccounts: AccountCategoryModel[];
  subAccountCategories: AccountCategoryModel[];
  setCostNumber?: React.Dispatch<React.SetStateAction<string>>;
  setName: React.Dispatch<React.SetStateAction<string>>;
  operasionalResource: TypeOperasionalResource;
  handleAction: (isOpen: boolean, id: number, action: 'delete' | 'update' | 'detail' | 'auhtorization') => void;
  handleOpenCarousel: (isOpen: boolean, id: number) => void;
}

const useStyles = makeStyles((theme: Theme) => ({
  cellTable: {
    width: '12%'
  },
  cellTableSecond: {
    width: '5%'
  },
  container: {
    minHeight: '30vh',
    borderTop: '1px solid rgba(45, 55, 72, 0.12)'
  },
  cellStartId: {
    width: '10%'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  select: {
    width: '150px',
    height: '40px'
  }
}));
const OperationalTable = ({
  financialAccounts,
  subAccountCategories,
  subAccountCategoriesId,
  setSubAccountCategoriesId,
  name,
  costNumber,
  setCostNumber,
  setName,
  operasionalResource,
  handleAction,
  handleOpenCarousel
}: Props) => {
  const classes = useStyles();

  const handleCategoryChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const selectedId = event.target.value ? parseInt(event.target.value as string, 10) : null;
    console.log('Selected subAccountCategoriesId:', selectedId);
    setSubAccountCategoriesId(selectedId);
  };

  return (
    <TableContainer>
      <TableCustom>
        <TableHead>
          <HeaderRow
            headers={[
              { id: 'id', label: 'id', align: 'center' },
              { id: 'createdAt', label: 'Tanggal', align: 'center' },
              { id: 'name', label: 'Nama', align: 'center' },
              { id: 'accountCategoriesName', label: 'Akun beban', align: 'center' },
              { id: 'financialAccountName', label: 'Akun keuangan', align: 'center' },
              { id: 'price', label: 'Nominal', align: 'center' },
              { id: 'akun', label: 'Vendor', align: 'center' },
              //{ id: 'tanggal', label: 'Tanggal Dibuat', align: 'center' },

              { id: 'image', label: 'Lampiran', align: 'center' },
              { id: 'action', label: 'Aksi', align: 'right' }
            ]}
          />
        </TableHead>
        <TableRow>
          <TableCellHead variant='head' className={classes.cellStartId}>
            <TextField id='costNumber' placeholder='Id' value={costNumber} onChange={event => setCostNumber?.(event.target.value)} />
          </TableCellHead>
          <TableCellHead />

          <TableCellHead variant='head' className={classes.cellTable}>
            <TextField id='name' style={{ height: '40px' }} placeholder=' Nama' value={name} onChange={event => setName?.(event.target.value)} />
          </TableCellHead>

          <TableCellHead variant='head' className={classes.cellTable}>
            <FormControl variant='outlined' className={classes.formControl}>
              <InputLabel id='demo-customized-select-label'> </InputLabel>
              <Select
                labelId='demo-customized-select-label'
                id='demo-customized-select'
                value={subAccountCategoriesId ?? ''}
                onChange={handleCategoryChange}
                // label='Age'
                className={classes.select}
              >
                <MenuItem value=''>Select Category</MenuItem>
                {subAccountCategories.map(category => (
                  <MenuItem key={category.id} value={category.id}>
                    {category.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* <Select
              value={subAccountCategoriesId ?? ''}
              onChange={handleCategoryChange}
              displayEmpty
              fullWidth
              inputProps={{ 'aria-label': 'Sub Account Category' }}
            >
              <MenuItem value=''>Select Category</MenuItem>
              {subAccountCategories.map(category => (
                <MenuItem key={category.id} value={category.id}>
                  {category.name}
                </MenuItem>
              ))}
            </Select> */}
          </TableCellHead>
          <TableCellHead />
          <TableCellHead />
        </TableRow>
        <TableBody>
          {operasionalResource.isLoading ? (
            <TableRow>
              <TableCell colSpan={10}>
                <Grid xs={12} container>
                  {[...new Array(5)].map((val, key) => (
                    <Grid xs={12}>
                      <Skeleton variant='text' animation='wave' height={60} key={key} />
                    </Grid>
                  ))}
                </Grid>
              </TableCell>
            </TableRow>
          ) : operasionalResource.data.length > 0 ? (
            operasionalResource.data.map((operasionalResource, key) => (
              <OperationalBody operasionalResource={operasionalResource} handleAction={handleAction} handleOpenCarousel={handleOpenCarousel} />
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={10} align='center'>
                <Grid xs={12} className={classes.container} container alignItems='center' justify='center'>
                  <Typography variant='h6'>Data Tidak Tersedia.</Typography>
                </Grid>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </TableCustom>
    </TableContainer>
  );
};

export default OperationalTable;
